









































































































































import Component from "vue-class-component";
import { Mixins, Watch } from "vue-property-decorator";
import ToolbarBtn from "../../components/ToolbarBtn.vue";
import { DataEditorMixin } from "../../../data-editor.mixin";
import { DataEditorToolMixin } from "./data-editor-tool.mixin";
import { groupBy } from "lodash";

@Component({
  components: {
    ToolbarBtn,

    WaveSelect: () => import("@/components/form/WaveSelect.vue"),
  },
})
export default class TransLongTool extends Mixins(
  DataEditorMixin,
  DataEditorToolMixin,
) {
  private menuActive = false;
  private activeTab = "lts";
  private options = [];

  private x: { label: string; value: number } | "" = "";
  private y: { label: string; value: number } | "" = "";
  private v: { label: string; value: number } | "" = "";

  private stl_x = true;
  private colHeaders = [];

  @Watch("menuActive")
  onMenuToggle(active) {
    if (!active) return;
    const headers = this.getHeaders();
    if (!headers || headers.length === 0) {
      this.$q.notify({
        type: "warn",
        message: this.$t("tool-bar-trans-long-empty-header-notify") as string,
      });
      return;
    }
    if (!this.compareHeaders(headers, this.headers)) {
      this.x = "";
      this.y = "";
      this.v = "";
    }
    this.headers = headers; // 存起来，下一次打开的时候需要对比
    this.colHeaders = this.getColHeaders();
    this.options = headers.map((label, value) => ({ label, value }));
  }

  get disableConfirmBtn() {
    return (
      this.activeTab === "lts" &&
      (!this.options ||
        this.options.length === 0 ||
        !this.x ||
        !this.y ||
        !this.v)
    );
  }

  /**
   * 长数据转短数据
   */
  lts() {
    const { dataEditorInstance } = this;
    const minimizedDataInEditor = this.getMinimizedDataInEditor();
    const { x, y, v } = this;
    if (!x || !y || !v) return;
    const ix = x.value,
      iy = y.value,
      iv = v.value;
    const body = minimizedDataInEditor.slice(1);
    const groupedDataX: any = groupBy(body, (row) => row[ix]);
    const groupedDataY: any = groupBy(body, (row) => row[iy]);
    const groupedDataXY: any = groupBy(body, (row) => row[ix]);
    Object.keys(groupedDataXY).forEach((key) => {
      groupedDataXY[key] = groupBy(groupedDataXY[key], (row) => row[iy]);
    });

    const headers = Object.keys(groupedDataX);
    const firstCol = Object.keys(groupedDataY);
    const finalData = [[""].concat(headers)];
    firstCol.forEach((y) => {
      const appendRow = [y];
      headers.forEach((x) => {
        if (
          groupedDataXY &&
          groupedDataXY[x] &&
          groupedDataXY[x][y] &&
          groupedDataXY[x][y].length > 0
        ) {
          appendRow.push(groupedDataXY[x][y][0][iv]);
        } else {
          appendRow.push("");
        }
      });
      finalData.push(appendRow);
    });

    // 更新到表格
    dataEditorInstance.setData(finalData);
    this.menuActive = false;
  }

  /**
   * 短数据转长数据
   */
  stl() {
    const originData = this.getMinimizedDataInEditor();
    const { stl_x, headers, colHeaders, dataEditorInstance } = this;
    const p = stl_x ? headers : colHeaders;
    const q = stl_x ? colHeaders : headers;
    const headerXY = [
      this.$t("tool-bar-trans-long-axis-x"),
      this.$t("tool-bar-trans-long-axis-y"),
    ];
    const finalData = [
      (stl_x ? headerXY : headerXY.reverse()).concat([
        this.$t("tool-bar-trans-long-value"),
      ]),
    ];

    p.forEach((i, iIndex) => {
      q.forEach((j, jIndex) => {
        if (!i || !j || !iIndex || !jIndex) return;
        const targetValue = stl_x
          ? originData[jIndex][iIndex]
          : originData[iIndex][jIndex];
        const row = [i, j, targetValue];
        finalData.push(row);
      });
    });
    console.log(JSON.stringify(finalData));
    dataEditorInstance.setData(finalData);
    this.menuActive = false;
  }
}
